import { render, staticRenderFns } from "./WalletPage.vue?vue&type=template&id=4b09b216&"
import script from "./WalletPage.vue?vue&type=script&lang=js&"
export * from "./WalletPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports